import { render, staticRenderFns } from "./tabla-productos.vue?vue&type=template&id=2dc754b5&scoped=true&"
import script from "./tabla-productos.vue?vue&type=script&lang=js&"
export * from "./tabla-productos.vue?vue&type=script&lang=js&"
import style0 from "./tabla-productos.vue?vue&type=style&index=0&id=2dc754b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dc754b5",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
